<picture>
  <source [srcset]="webpSrc" type="image/webp" />
  <img
    [src]="src"
    [alt]="alt"
    [attr.width]="width"
    [attr.height]="height"
    [attr.loading]="loading"
    [attr.fetchpriority]="fetchpriority"
    [class]="class"
  />
</picture>
